import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
      <div class="poem">
        <p class="poem-block mb-3">
          Тебе сегодня ровно год,<br/>
          Начало жизни длинной.<br/>
          Пусть в радости она пройдёт,<br/>
          Пусть будет жизнь малиной.
        </p>

        <p class="poem-block mb-3">
          Живи, расти и познавай<br/>
          Прекрасный мир широкий.<br/>
          Пусть будет мил родимый край<br/>
          И близок край далёкий.
        </p>

        <p class="poem-block mb-3">
          Люби и будь любим всегда<br/>
          Друзьями и семьёю,<br/>
          И пусть счастливая звезда<br/>
          Сияет над тобою.
        </p>

        <p class="poem-block mb-3">
          И повторю я, не стыдясь,<br/>
          С надеждою на чудо:<br/>
          «Пусть будет добрым ум твой, Ясь,<br/>
          А сердце умным будет!».
        </p>
      </div>
    `
  )
}

const itemName = {
  rus: 'Внуку'
}
const itemDate = {
  rus: '15 ноября 2006'
}

const item = {
  itemlink: getLink(itemName.rus),
  rus:{
    itemName: itemName.rus,
    itemDate: itemDate.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}


export default item;